import App from '@app/app.js';
import template from './category-list.html';
import './category-list.scss';

class CategoryListController {
  slide(direction) {
    this.sideScroll(direction);
    this.calculateSlideBtnVisibilityState();
  }

  sideScroll(direction, distance = 100) {
    const container = document.getElementById(this.mobileId);
    if (direction === 'left') {
      container.scrollLeft -= distance;
    } else {
      container.scrollLeft += distance;
    }
  }

  calculateSlideBtnVisibilityState() {
    const container = document.getElementById(this.mobileId);
    const leftBtn = container.querySelector('#slide-left');
    const rightBtn = container.querySelector('#slide-right');
    const maxRightPosition = container.scrollWidth - container.offsetWidth - 1;

    if (container.scrollLeft === 0) {
      leftBtn.classList.add('hidden-xs');
    } else {
      leftBtn.classList.remove('hidden-xs');
    }

    if (container.scrollLeft > maxRightPosition) {
      rightBtn.classList.add('hidden-xs');
    } else {
      rightBtn.classList.remove('hidden-xs');
    }
  }

  selectLookCategory(category) {
    this.onSelectCategory({ category });
  }
}
App.component('ltCategoryList', {
  template,
  bindings: {
    mobileId: '<',
    selectedCategory: '<',
    categoriesList: '<',
    onSelectCategory: '&'
  },
  controller: CategoryListController,
  controllerAs: 'categoryCtrl'
});
